import type { CSSProperties, ReactNode } from "react";
import { PALETTES, paletteStyle, type Palette } from "../pattern2/palettes";

/* The team's "Team mix" (Oct 2026): each homepage section takes the palette
   roles it looked best in during the palette review. Pages wrap each section
   in <Part> so it gets its own --k-* tokens; the club page reuses the parts of
   the homepage sections it mirrors. */

export type PartName = "hero" | "making" | "club" | "words" | "faves" | "where" | "brands" | "loop" | "footer";
const byKey = (key: string) => PALETTES.find(p => p.key === key)!;

const PARTS: Record<PartName, string> = {
  hero: "secondaries", making: "periwinkle", club: "teal-coral", words: "teal-coral", faves: "teal-coral",
  where: "secondaries", brands: "teal-coral", loop: "teal-coral", footer: "teal-coral",
};
// The nav's "Sew with me" matches the hero's golden "Get to know me" instead of olive.
const TWEAKS: Partial<Record<PartName, Partial<Palette>>> = { hero: { cta: "#F0BE3C", ctaInk: "#0B302A" } };
// Hero background: a brighter blue than cobalt, picked by the team; cream text reads at 5.8:1.
const HERO_BLUE = "#05649B";

/** Page-root tokens: paper and ink come from teal-coral, shared by every part. */
export const rootStyle = { ...paletteStyle(byKey("teal-coral")), "--k-hero": HERO_BLUE } as CSSProperties;

export function Part({ p, children }: { p: PartName; children: ReactNode }) {
  return <div style={{ display: "contents", ...paletteStyle({ ...byKey(PARTS[p]), ...TWEAKS[p] }) }}>{children}</div>;
}
